import React from 'react';
import { Flex, Box, Text } from 'rebass/styled-components';
import styled from 'styled-components';

const Option = styled(Flex)`
  cursor: pointer;
  border-radius: 5px;
  background-color: #e5e5ee;
  margin: 0 0 10px 0;
  &:hover {
    background-color: #c3c1e5;
  }
`;

const Letter = styled(Box)`
  border-radius: 5px;
  font-size: 14px;
`;

const OptionBox = ({ letter, text, isActive, name, next, setOptionBox }) => {
  return (
    <Option
      alignItems="center"
      py={2}
      width={[1]}
      onClick={() => setOptionBox(text, name, next)}
      style={{
        border: isActive ? 'solid 3px #726DE1' : 'solid 1px #726DE1'
      }}
    >
      <Letter
        py={isActive ? 0 : 1}
        px={isActive ? 1 : 2}
        mx={2}
        sx={{
          border: isActive ? 'solid 3px #726DE1' : 'solid 1px #726DE1',
          backgroundColor: isActive ? '#726DE1' : '#F8F8F8',
          color: isActive ? '#FFFFFF' : '#726DE1'
        }}
      >
        {letter}
      </Letter>
      <Text color="lilac" fontSize={5}>
        {text}
      </Text>
    </Option>
  );
};

export default OptionBox;
